/* eslint-disable react/prop-types */
import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const YoutubePopup = props => {
  const { srcImage, urlVideo } = props;
  const [isOpen, setIsOpen] = useState(false);

  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);

  return (
    <div>
      <figure>
        <img
          src={srcImage}
          className="contentMedia"
          alt="thumbnail"
          style={{ cursor: "pointer" }}
          onClick={openPopup}
        />
      </figure>

      <Dialog
        open={isOpen}
        onClose={closePopup}
        maxWidth="md"
        fullWidth
        className="videoPopup"
      >
        <IconButton
          onClick={closePopup}
          style={{ position: "absolute", right: 2, top: 2, color: "white" }}
        >
          <Close />
        </IconButton>
        <DialogContent>
          <ReactPlayer
            className="videoLogin"
            url={urlVideo}
            controls={false}
            width="100%"
            // height="100%"
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default YoutubePopup;
